import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Sin lácteos',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Picante',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Vegano',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Sin gluten',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Vegetariano',
};
